// extracted by css-extract-rspack-plugin
export default {"actions-menu-mobile":"ActionsMenuMobile_actions-menu-mobile__Ts+4f","divider":"ActionsMenuMobile_divider__Ikdtx"};